import ModalComponent from "..";
import { Button } from "../../buttons/button";
import { InfoComponent } from "../../notification/infoComponent";
import { BaseApiErrorResponse } from "../../../utils/types";
import { formatDate } from "../../../utils/helpers";
import { HolidayDateBadge } from "../../dateBadge";

export const ConfirmHolidayModal = ({
  open,
  handleBack,
  handleClose,
  handleAddHoliday,
  name,
  holidayDate,
  nextWorkingDay,
  addingHoliday,
  error,
  isError,
}: {
  open: boolean;
  handleBack: () => void;
  handleClose: () => void;
  handleAddHoliday: () => void;
  name: string;
  holidayDate: string;
  nextWorkingDay: string;
  addingHoliday: boolean;
  isError: boolean;
  error: BaseApiErrorResponse;
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
      }}
      handleBack={() => {
        handleBack();
      }}
      title={"Confirm New Public Holiday"}
      subtitle="We would send an email to all organizers expecting payouts on this day to let them know that their payout would be delayed and paid on the next working day."
      showHeader
      showBackIcon={false}
      mobileAnchorBottom
      showBackButton={true}
      showCloseIcon={false}
    >
      <div className="flex flex-col gap-6">
        {isError && (
          <InfoComponent
            title="Error"
            text={
              (error as unknown as BaseApiErrorResponse)?.data?.message ??
              "An error occurred!"
            }
            type="error"
          />
        )}
        <div className="flex gap-2.5 rounded-lg border border-grey-100 px-3 py-2.5">
          <HolidayDateBadge holidayDate={holidayDate} />
          <div className="flex flex-col gap-1">
            <p className="font-bold text-grey-900">{name}</p>
            <p className="text-sm text-grey-600">
              Work resumes {formatDate(nextWorkingDay)}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2">
          <Button
            text="Cancel"
            type="button"
            onClick={handleClose}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text="Add Holiday"
            type="button"
            onClick={handleAddHoliday}
            loading={addingHoliday}
            variation="primary"
            className="max-w-fit"
          />
        </div>
      </div>
    </ModalComponent>
  );
};
